var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"list-group-item no-kits"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-7"},[_c('h3',[_vm._v("You don't have any kits")]),_vm._v(" "),_c('p',[_vm._v("Start your journey now by purchasing or redeeming a kit.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7976eece","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/noKits.vue
// module id = kpb1
// module chunks = 1